import { State } from "state/store"

export const getSelectedMotif = (state: State) => state.motif.selectedMotif
